import { Link } from "react-router-dom";

interface ConditionalLinkProps {
  name: string;
  machineLink: string;
  defaultLink: string;
  state?: object; // Accept state as a prop
  children: React.ReactNode;
}

const ConditionalLink: React.FC<ConditionalLinkProps> = ({
  name,
  machineLink,
  defaultLink,
  state,
  children,
}) => {
  const linkTo = name === "Machines" ? machineLink : defaultLink;
  return <Link to={{ pathname: linkTo }}  state={state}  style={{ textDecoration: "none" }}>{children}</Link>;
};

export default ConditionalLink;
